import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid2";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import CalendarEventViewModel from "../Organisation/ViewModels/CalendarDayViewModel";

interface IProps {
    events: CalendarEventViewModel[];
    dayOfMonthIndex: number;
    isToday: boolean;
    isWeekend: boolean;
}

export default function CalendarDay(props: IProps) {
    const { events, dayOfMonthIndex, isToday, isWeekend } = props;

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const visibleEvents = events.slice(0, 3);
    const hiddenEvents = events.length > 3 ? events.slice(3) : [];
    const navigate = useNavigate();


    const squareStyle = {
        position: "relative",
        width: "100%",
        height: "110px",
        border: isToday ? "5px solid #0188ac" : "2px solid #ccc",
        boxSizing: "border-box",
        backgroundColor: isToday ? "#f7f7f8" : isWeekend ? "#f5f5f5" : "white",
        boxShadow: isToday ? "inset 0 0 0 2px rgba(1,136,172,0.15)" : "none",
        padding: "4px",
        display: "flex",
        flexDirection: "column",
    };


    const eventBoxStyle = (color: string) => ({
        backgroundColor: color,
        borderRadius: isToday ? "20px" : "8px",
        padding: "2px 6px",
        marginBottom: "2px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        fontSize: "0.7rem",
        color: "#fff",
    });

    const handleMoreClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };


    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <Grid size={12 / 7}>
            <Box sx={squareStyle}>
                <Typography variant="caption" sx={{ fontWeight: 'bold', color: isToday ? "#016f8e" : "inherit" }}>
                    {dayOfMonthIndex}
                </Typography>
                {visibleEvents.map((event, index) => (
                    <Tooltip title={event.name} key={index}>
                        <Box onClick={() => navigate(`/admin/manageorganisation?organisationid=${event.id}`)} sx={eventBoxStyle(event.color)}>
                            {event.licenseNumber + " " + event.name}
                        </Box>
                    </Tooltip>
                ))}
                {hiddenEvents.length > 0 && (
                    <>
                        <Button onClick={handleMoreClick} sx={{ fontSize: '0.7rem', padding: 0, minHeight: 0, minWidth: 0 }}>
                            +{hiddenEvents.length} more
                        </Button>
                        <Popover
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                            slotProps={{
                                paper: {
                                    sx: {
                                        width: anchorEl?.offsetWidth || 'auto',
                                        maxWidth: '200px',
                                        p: 1,
                                    }
                                }
                            }}
                        >
                            <Box>
                                {hiddenEvents.map((event, index) => (
                                    <Tooltip title={event.name} key={index}>
                                        <Box onClick={() => navigate(`/admin/manageorganisation?organisationid=${event.id}`)} sx={{ ...eventBoxStyle(event.color) }}>
                                            {event.licenseNumber + " " + event.name}
                                        </Box>
                                    </Tooltip>
                                ))}
                            </Box>
                        </Popover>
                    </>
                )}
            </Box>
        </Grid>
    );
}



